import { render, staticRenderFns } from "./FieldSize.vue?vue&type=template&id=637faf82&"
import script from "./FieldSize.vue?vue&type=script&lang=js&"
export * from "./FieldSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports